import React from 'react';
import { Mail } from 'lucide-react';
import '../trust-homepage.css';

const WhatsAppIcon: React.FC = () => (
  <svg
    className="trust-team__action-icon"
    data-contact-icon="whatsapp"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.693.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26C2.169 6.434 6.603 2 12.062 2c2.643 0 5.127 1.03 6.994 2.898a9.825 9.825 0 0 1 2.896 6.994c-.002 5.459-4.435 9.893-9.901 9.893m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.479-8.413Z"
    />
  </svg>
);

export const WhoWeAreSection: React.FC = () => (
  <section className="trust-section trust-team" aria-labelledby="who-we-are-title">
    <div className="marketing-grid trust-team__layout">
      <div className="trust-team__intro">
        <h1 id="who-we-are-title">Quiénes somos</h1>
        <p>
          Áncora es una empresa tecnológica, nacida en Madrid, que crea empleados digitales conectados a
          las herramientas de tu negocio. Gestionan las tareas del día a día para que el trabajo sea más
          eficaz y tu equipo dedique menos tiempo a procesos repetitivos.
        </p>
      </div>
      <div className="trust-team__story">
        <h2>Somos un equipo que escucha antes de proponer</h2>
        <div className="trust-team__story-copy">
          <p>
            En Áncora combinamos conocimiento tecnológico y experiencia en gestión para crear empleados
            digitales que resuelven necesidades concretas.
          </p>
          <p>
            No ofrecemos una solución igual para todos. Cada proyecto se adapta al negocio, a sus
            herramientas y a la forma en que trabaja su equipo.
          </p>
        </div>
      </div>
      <div className="trust-team__followup">
        <p className="trust-team__decision">
          ¡Tú decides y eliges cómo nuestro sistema, hecho a tu medida, puede ayudarte con la gestión de tu operativa diaria!
        </p>
        <div className="trust-team__actions" aria-label="Contactar con Áncora">
          <a className="trust-team__action trust-team__action--primary" href="https://wa.me/34614046352" target="_blank" rel="noreferrer">
            <WhatsAppIcon />
            <span>Escribir por WhatsApp</span>
          </a>
          <a className="trust-team__action trust-team__action--secondary" href="mailto:automatiza@ancoraautomations.es">
            <Mail className="trust-team__action-icon" data-contact-icon="email" aria-hidden="true" size={20} />
            <span>Enviar un correo</span>
          </a>
        </div>
      </div>
    </div>
  </section>
);
